import { Modal as MuiModal } from '@mui/material'
import { styled } from '../../utils/styled'
import Button from '../Button'
import Grid from '../Grid'

export const StyledPopUpBackdrop = styled(MuiModal)(() => ({
  overflowY: 'auto',
  paddingTop: '5%',
  paddingBottom: '5%'
}))

export const StyledPopUp = styled(Grid)<{ $compact: boolean }>(({ theme, $compact: compact }) => ({
  width: '640px',
  backgroundColor: theme.tokens.background.main.default,
  border: `1px solid ${theme.tokens.border.main.tonal}`,
  margin: 'auto',
  borderRadius: theme.borderRadius.xxLarge,
  boxShadow: theme.elevation.largeDepth,
  boxSizing: 'border-box',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'flex-start',
  padding: compact ? '16px 32px' : '32px',
  gap: '4px',
  outline: 'none',
  zIndex: theme.zIndex.modal
}))

export const StyledContentBox = styled(Grid)(() => ({
  padding: '16px',
  width: '100%'
}))

export const StyledHeaderRow = styled('div')(() => ({
  width: '100%',
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'space-between',
  flexWrap: 'nowrap',
  gap: '8px'
}))

export const StyledBackButtonWrapper = styled('div')(() => ({
  '& > .MuiButtonBase-root': {
    padding: '4px 8px',
    minWidth: 'auto'
  }
}))

export const StyledCloseButton = styled(Button)(({ theme }) => ({
  h4: {
    fontSize: theme.typography.body2.fontSize
  }
}))
